/**************************************************************************************************/
/*   File: /src/app/shared/models/local.document.ts                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocumentContent } from './local.document.content';
import { LocalDocumentId } from './local.document.id';
import { LocalDocumentInfo } from './local.document.info';

/**
 * The local document
 */
export class LocalDocument {
    /**
     * The local document content
     */
    content: LocalDocumentContent;
    /**
     * The description
     */
    description: string;
    /**
     * The local document id
     */
    id: LocalDocumentId;
    /**
     * The local document info
     */
    info: LocalDocumentInfo;
    /**
     * The name
     */
    name: string;
}